import React from "react";

import { connect } from "react-redux";
import { Formik, Field } from "formik";
import { Alert, AlertTitle } from "@material-ui/lab";

import TextField from "../../components/CstmTextField";
import ScreenWrapper from "../../components/ScreenWrapper";

import resetPassword from "../../actions/resetPassword.actions";

const EnterCode = ({ resetPwd, showError }) => {
  return (
    <ScreenWrapper showProgress={false}>
      <Formik
        initialValues={{ code: "", reset_pass: "", confirm_pass: "" }}
        validate={validate}
        onSubmit={(values) => {
          resetPwd(values);
        }}
      >
        {({ handleSubmit }) => (
          <React.Fragment>
            {showError === true && (
              <React.Fragment>
                <Alert severity="error">
                  <AlertTitle>Error</AlertTitle>
                  Invalid Reset Password Code.
                </Alert>
                <br />
              </React.Fragment>
            )}

            <Field
              name="code"
              label="Reset Password Code"
              component={TextField}
              required
            />

            <Field
              name="reset_pass"
              label="Password"
              type="password"
              component={TextField}
              required
              style={{ marginTop: 10 }}
            />

            <Field
              name="confirm_pass"
              label="Confirm Password"
              type="password"
              component={TextField}
              required
              style={{ marginTop: 10 }}
            />

            <div style={{ marginTop: 10 }}>
              <div style={{ float: "right" }}>
                <button
                  type="button"
                  className="cstm_btn cstm_btn-blue"
                  onClick={handleSubmit}
                >
                  Reset Password
                </button>
              </div>
            </div>
          </React.Fragment>
        )}
      </Formik>
    </ScreenWrapper>
  );
};

const validate = (values) => {
  let errors = {};

  if (!values.code) {
    errors.code = "Required";
  }

  if (!values.reset_pass) {
    errors.reset_pass = "Required";
  }

  if (!values.confirm_pass) {
    errors.confirm_pass = "Required";
  }

  if (
    values.reset_pass !== "" &&
    values.confirm_pass !== "" &&
    values.reset_pass !== values.confirm_pass
  ) {
    errors.confirm_pass = "Please confirm your password";
  }
};

const mapState = (state) => {
  return {
    showError: state.resetPassword.showError,
  };
};

const mapDispatch = (dispatch) => {
  return {
    resetPwd: (values) => {
      dispatch(resetPassword(values));
    },
  };
};

export default connect(mapState, mapDispatch)(EnterCode);



// WEBPACK FOOTER //
// ./src/Screens/ResetPassword/EnterCode.js